import axiosInstance from "../../axiosInstance/axiosInstance";
import { ClockifyTimeEntryChangedMapper } from "../ClockifyTimeEntryChangedMapper";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ClockifyTimeEntryTimeChangedAlertResponse } from "./ClockifyTimeEntryTimeChangedAlertResponse";

export const loadClockifyTimeChangedAlertsByMilestoneIdAsync = createAsyncThunk(
  "clockifyTimeChangedAlerts/getByMilestoneId",
  async (milestoneId: number) => {
    const response = await axiosInstance.get<
      ClockifyTimeEntryTimeChangedAlertResponse[]
    >(`/ClockifyTimeEntryTimeChangedAlerts/${milestoneId}`);
    var clockifyTimeEntryChangedMapper = new ClockifyTimeEntryChangedMapper();
    return response.data.map((response) =>
      clockifyTimeEntryChangedMapper.mapToClockifyTimeEntryChangedAlert(
        response
      )
    );
  }
);
